module.exports = {"id":"211703","name":"Marc Schnatterer","rating":"75","photo":"./data/images/photos/2/211703.png","club":{"name":"1. FC Heidenheim","logo":"./data/images/clubs/1.FCHeidenheim.png"},"positions":["MD","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcSchnatterer0.json
// module id = 2703
// module chunks = 0